import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import LanguageStore from '../../store/LanguageStore';
import VideoListStore from '../../store/VideoListStore';
import DateService from '../../services/DateService';

const MetaTags = observer(() => {
    const { language } = LanguageStore;
    const { trackedAt } = VideoListStore;

    useEffect(() => {
        // Форматируем дату для мета-тегов
        const formattedDate = DateService.formatDateForMeta(trackedAt, language);
        
        // Получаем title и description из локалей
        const title = LanguageStore.t('metaTitle', formattedDate);
        const description = LanguageStore.t('metaDescription', formattedDate);

        // Устанавливаем title
        document.title = title;

        // Обновляем или создаем meta description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.setAttribute('name', 'description');
            document.head.appendChild(metaDescription);
        }
        metaDescription.setAttribute('content', description);

        // Обновляем или создаем og:title
        let ogTitle = document.querySelector('meta[property="og:title"]');
        if (!ogTitle) {
            ogTitle = document.createElement('meta');
            ogTitle.setAttribute('property', 'og:title');
            document.head.appendChild(ogTitle);
        }
        ogTitle.setAttribute('content', title);

        // Обновляем или создаем og:description
        let ogDescription = document.querySelector('meta[property="og:description"]');
        if (!ogDescription) {
            ogDescription = document.createElement('meta');
            ogDescription.setAttribute('property', 'og:description');
            document.head.appendChild(ogDescription);
        }
        ogDescription.setAttribute('content', description);

        // Обновляем lang атрибут html
        document.documentElement.lang = language === 'ru' ? 'ru' : 'en';
    }, [trackedAt, language]);

    return null;
});

export default MetaTags;













